export var SymphonyColors;

(function (SymphonyColors) {
  SymphonyColors["clear"] = "clear";
  SymphonyColors["base"] = "base";
  SymphonyColors["baseLighter"] = "baseLighter";
  SymphonyColors["primary"] = "primary";
  SymphonyColors["secondary"] = "secondary";
  SymphonyColors["loading"] = "loading";
  SymphonyColors["shade05"] = "shade05";
  SymphonyColors["shade10"] = "shade10";
  SymphonyColors["shade20"] = "shade20";
  SymphonyColors["shade40"] = "shade40";
  SymphonyColors["shade60"] = "shade60";
  SymphonyColors["shade80"] = "shade80";
  SymphonyColors["confirm"] = "confirm";
  SymphonyColors["inform"] = "inform";
  SymphonyColors["warn"] = "warn";
  SymphonyColors["stop"] = "stop";
  SymphonyColors["brand1"] = "brand1";
  SymphonyColors["brand2"] = "brand2";
  SymphonyColors["brand3"] = "brand3";
  SymphonyColors["brand4"] = "brand4";
  SymphonyColors["brand5"] = "brand5";
})(SymphonyColors || (SymphonyColors = {}));

export var colors = {
  clear: "transparent",
  base: "#D8D8D8",
  baseLighter: "#F6F6F6",
  primary: "#000000",
  secondary: "#FFFFFF",
  loading: "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.1) 100%)",
  shade05: "rgba(0,0,0,0.05)",
  shade10: "rgba(0,0,0,0.1)",
  shade20: "rgba(0,0,0,0.2)",
  shade40: "rgba(0,0,0,0.4)",
  shade60: "rgba(0,0,0,0.6)",
  shade80: "rgba(0,0,0,0.8)",
  confirm: "#1C5F4A",
  inform: "#4670DB",
  warn: "#D8A158",
  stop: "#BB4725",
  brand1: "#D8A158",
  brand2: "#BB4725",
  brand3: "#1C5F4A",
  brand4: "#BDD2E7",
  brand5: "#F1D9D8"
};
export var darkColors = {
  clear: "transparent",
  base: "#262626",
  baseLighter: "#090909",
  primary: "#FFFFFF",
  secondary: "#000000",
  loading: "linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,0.1) 100%)",
  shade05: "rgba(255,255,255,0.05)",
  shade10: "rgba(255,255,255,0.1)",
  shade20: "rgba(255,255,255,0.2)",
  shade40: "rgba(255,255,255,0.4)",
  shade60: "rgba(255,255,255,0.6)",
  shade80: "rgba(255,255,255,0.8)",
  confirm: "#1C5F4A",
  inform: "#4670DB",
  warn: "#D8A158",
  stop: "#BB4725",
  brand1: "#D8A158",
  brand2: "#BB4725",
  brand3: "#1C5F4A",
  brand4: "#BDD2E7",
  brand5: "#F1D9D8"
};